var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 16.175L0 15L5 7L8 10.5L12 4L14.725 8.075C14.3417 8.09167 13.979 8.13733 13.637 8.212C13.2957 8.28733 12.9583 8.39167 12.625 8.525L12.075 7.7L8.275 13.875L5.25 10.35L1.625 16.175ZM20.575 21L17.45 17.875C17.1167 18.1083 16.7457 18.2833 16.337 18.4C15.929 18.5167 15.5083 18.575 15.075 18.575C13.825 18.575 12.7627 18.1373 11.888 17.262C11.0127 16.3873 10.575 15.325 10.575 14.075C10.575 12.825 11.0127 11.7623 11.888 10.887C12.7627 10.0123 13.825 9.575 15.075 9.575C16.325 9.575 17.3877 10.0123 18.263 10.887C19.1377 11.7623 19.575 12.825 19.575 14.075C19.575 14.5083 19.5167 14.929 19.4 15.337C19.2833 15.7457 19.1083 16.125 18.875 16.475L22 19.575L20.575 21ZM15.075 16.575C15.775 16.575 16.3667 16.3333 16.85 15.85C17.3333 15.3667 17.575 14.775 17.575 14.075C17.575 13.375 17.3333 12.7833 16.85 12.3C16.3667 11.8167 15.775 11.575 15.075 11.575C14.375 11.575 13.7833 11.8167 13.3 12.3C12.8167 12.7833 12.575 13.375 12.575 14.075C12.575 14.775 12.8167 15.3667 13.3 15.85C13.7833 16.3333 14.375 16.575 15.075 16.575ZM17.3 8.575C16.9833 8.44167 16.654 8.33333 16.312 8.25C15.9707 8.16667 15.6167 8.11667 15.25 8.1L20.375 0L22 1.175L17.3 8.575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProBusinessIcon);
export default __webpack_public_path__ + "static/media/pro-business-icon.f26eeb6651b4aeb0479c5c934dfbc8d1.svg";
export { ForwardRef as ReactComponent };